import Proxy from './Proxy';

class MediaInfoProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/media-info', parameters);
  }

  /**
   * 매체별 카운트
   * @param mediaType
   * @returns {Promise}
   */
  getMediaCountByMediaType(mediaType) {
    return this.submit('get', `/${this.endpoint}/status/${mediaType}`);
  }

}

export default MediaInfoProxy;
